export default "__VITE_ASSET__C0o3qN3I__"